function ScrollAwareNav({ element }) {
  const navItems = element.querySelectorAll("li > button");
  const navSectionWrapper = document.querySelector(
    `#${element.id}-section-wrapper`
  );

  const sections = navSectionWrapper.querySelectorAll("section");

  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.001,
  };

  function observerCallback(entries, observer) {
    const entry = entries.filter((entry) => entry.isIntersecting)[0];
    if (entry) {
      const index = entry.target.dataset.index;
      const navItem = navItems[index];
      // add 'active' class on the navItem
      navItem.classList.add("active");
      // remove 'active' class from any navItem that is not
      // same as 'navItem' defined above
      Object.values(navItems).forEach((item) => {
        if (item != navItem) {
          item.classList.remove("active");
        }
      });
    }
  }

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  sections.forEach((sec) => {
    observer.observe(sec);
  });

  navItems.forEach((navItem, index) => {
    navItem.addEventListener("click", function () {
      const relatedSection = sections[index];
      if (relatedSection) {
        relatedSection.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
        navItem.classList.add("active");
        // remove 'active' class from any navItem that is not
        // same as 'navItem' defined above
        Object.values(navItems).forEach((item) => {
          if (item != navItem) {
            item.classList.remove("active");
          }
        });
      }
    });
  });
}

function isElementVisible(el) {
  var rect = el.getBoundingClientRect(),
    vWidth = window.innerWidth || document.documentElement.clientWidth,
    vHeight = window.innerHeight || document.documentElement.clientHeight,
    efp = function (x, y) {
      return document.elementFromPoint(x, y);
    };

  // Return false if it's not in the viewport
  if (
    rect.right < 0 ||
    rect.bottom < 0 ||
    rect.left > vWidth ||
    rect.top > vHeight
  )
    return false;

  // Return true if any of its four corners are visible
  return (
    el.contains(efp(rect.left, rect.top)) ||
    el.contains(efp(rect.right, rect.top)) ||
    el.contains(efp(rect.right, rect.bottom)) ||
    el.contains(efp(rect.left, rect.bottom))
  );
}
